import React, { Component } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import color from '../../utils/colors';

import AnimationContainer from '../FadeAnimation';
import Paragraph from './Paragraph';
// import LikeCounter from '../LikeCounter';
import fullSize from './FullSize';

export class CaseWithResize extends Component {
    render() {
        const {
            className, handleOpenPopUp, caseData: { uuid, poster, description }, fade, handleOpen,
        } = this.props;

        return (
            <Root className={className} fade={fade}>
                <Paragraph handleOpen={handleOpen} uuid={uuid} img={poster[0]} text={description} />
                <ReadMoreButton
                    onClick={() => handleOpenPopUp(fullSize, { id: uuid })}
                >
                    Читать полностью
                </ReadMoreButton>
                {/* <LikeCounter count={likes} /> */}
            </Root>
        );
    }
}

const ReadMoreButton = styled.button`
    margin-top: 4px;
    margin-bottom: 8px;
    padding: 0;
    font-size: 16px;
    line-height: 21px;
    color: ${color.SECONDARY};
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;

    :active {
        color: #002679;
    }

    :hover {
        color: #002679;
    }
`;

const Root = styled(AnimationContainer)`
    width: 328px;

    ${mediaWidth.m} {
        width: 320px;
    };

    ${mediaWidth.l} {
        width: 283px;
    };

    ${mediaWidth.xl} {
        width: 404px;
    };
`;

export default CaseWithResize;
